<template>
  <div class="third-list">
    <!-- 表格 -->
    <table border="1" class="third-list__table" v-if="tableData.length > 0">
      <thead>
        <tr>
          <!-- 表头 -->
          <th v-for="(header, index) in headers" :key="index">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <!-- 表格数据 -->
        <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
          <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>
        </tr>
      </tbody>
    </table>
    <!-- 如果没有数据，显示提示 -->
    <p v-else>暂无数据</p>
  </div>
</template>

<script>
export default {
  name: 'ThirdList',
  data() {
    return {
      // 默认表头（7列）
      headers: ['产品类型', '使用目的', '使用场景', '个人信息收集类型', '收集方式', '第三方公司名称（简称）', '隐私保护说明'],
      tableData: [
        ['百度地图SDK', '地理位置获取', '提供区域的权益服务', '设备信息、网络信息、经纬度信息', 'SDK本机采集，不涉及共享', '百度网讯科技', 'https://lbsyun.baidu.com/index.php?title=openprivacy'],
        ['上海七牛信息技术SDK', '调用存储在七牛的图片及视频调用', '用于服务的图片以及视频展示', '设备信息、网络类型', 'SDK本机采集，不涉及共享', '七牛信息科技', 'https://developer.qiniu.com/pili/8027/sdk-privacy-policy'],
        ['深圳万里通SDK', '调用壹钱包登录、积分兑换接口', '调用查询万里通积分，用于积分查询、兑换', '设备信息、网络类型', 'SDK本机采集，不涉及共享', '壹钱包', 'https://d.1qianbao.com/youqian/1qianbaoPrivacyAgreement.html'],
        ['百度定位 SDK', '模糊地理位置（经纬度）', '通过定位服务，推荐附近的网点、加油站', '设备信息、操作系统版本、设备品牌及型号、经纬度、位置信息、网络信息', 'SDK本机采集，不涉及共享', '百度网讯科技', 'https://lbsyun.baidu.com/index.php?title=openprivacy'],
        ['百度统计sdk', '页面浏览数据统计', '网页使用统计及分析', '设备信息、访问时间、页面停留时间、设备品牌型号、操作系统版本、分辨率、网络信息', 'SDK本机采集，不涉及共享', '百度网讯科技', 'https://tongji.baidu.com/web/help/article?id=330&type=0&castk=LTE%3D '],
        ['二手车之家SDK', '二手车信息查询调用', '二手车信息查询及推荐展示', '设备信息、网络类型', 'SDK本机采集，不涉及共享', '汽车之家', 'https://baojia.m.autohome.com.cn/static/privacy-policy.html'],
        ['高德地图SDK', '模糊地理位置（经纬度）', '通过定位服务，推荐附近的网点、加油站', '设备信息、网络信息、经纬度信息', 'SDK本机采集，不涉及共享', '高德科技', 'https://cache.amap.com/h5/h5/publish/238/index.html'],
        ['天眼sdk', '埋点统计', '用于数据统计', '设备信息、设备型号、操作系统sdk版本、cpu型号、国家、运营商、语言、时区、手机操作系统版本、是否有网络连接、网络类型、设备操作系统', 'SDK本机采集，不涉及共享', '平安科技', 'https://maam-res.pingan.com.cn/web/PaDailyNews/index.html#/article/A00000018'],
        ['腾讯地图', '模糊地理位置（经纬度）', '通过定位服务，推荐附近的网点、加油站', '设备信息、网络信息、经纬度信息', 'SDK本机采集，不涉及共享', '腾讯科技', 'https://privacy.qq.com/document/preview/4cf61fd47f584dae83758bb0f11c1533'],
        ['SPARATA-SDK', '安全风控', '供业务方调用提供安全设备标识，加强安全风控，规避业务风险', '应用的版本、版本号、包名、唯一设备识别码（IMEI、AndroidID）、广告 ID（苹果系统为 IDFA）、设备基础信息、IMSI、SSID、MAC、地理位置信息、IP、网络状态信息、WIFI热点信息、蓝牙信息、传感器信息。', 'SDK本机采集，不涉及共享', '平安科技', 'https://resources.pingan.com/app_series/tech-static/policy/Sparta-Developer-Tips-And-Personal-Information-Protection.pdf'],
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.third-list {
    font-size: 20px;
    transform: scale(0.5);
    transform-origin: 0 0;
}
.third-list__table {
  width: 200%;
  border-collapse: collapse;
  margin-top: 20px;
}

.third-list__table th,
.third-list__table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
  word-break: break-all;
  width: 10%;
}
</style>